module.exports = __webpack_public_path__ + "static/media/XIVh.35509c04.png";